/**
 * 대금상환 팝업 공통 mixin (TASK-161 라운드 ⓒ)
 * ------------------------------------
 *  - 페이지당 1 인스턴스 + 행 버튼이 open(row) 로 데이터 주입 (row = page.cod_rows[id], 컨트롤러 codRowsJson)
 *  - ajax = $.app.ajax.module.default (실패 = 서버 메세지 alert 기본 처리 — 문구는 서버 Logic 그대로)
 *  - 성공 = 서버 msg alert 후 location.reload() (결정 10-④ 관행 — buy-order/edit-layer.vue 동일)
 */
export default {
    data: function () {
        return {
            // 주입된 행 데이터
            row: null,

            // 요청중
            busy: false,
        };
    },
    computed: {
        // 트래킹번호(들) 표시
        trackingText() {
            if (! this.row || ! this.row.tracking_nos || this.row.tracking_nos.length === 0) {
                return '-';
            }
            return this.row.tracking_nos.join(', ');
        },

        // 대금상환금액 표시
        reqAmountText() {
            return this.row ? this.priceText(this.row.req_amount, this.row.currency) : '-';
        },

        // 창고지급액 표시
        paidAmountText() {
            return this.row ? this.priceText(this.row.paid_amount, this.row.currency) : '-';
        },
    },
    methods: {
        normalize(val) {
            return (val === null || val === undefined) ? '' : String(val).trim();
        },

        // 금액 표시 (JPY 소수점 없음)
        priceText(val, currency) {
            let s = this.normalize(val);
            if (s === '') {
                return '-';
            }
            let num = parseFloat(s);
            if (isNaN(num)) {
                return s;
            }
            let digits = currency === 'JPY' ? 0 : 2;
            return (currency ? currency + ' ' : '') + this.$formatNumber(num, digits);
        },

        // 오늘 (Y-m-d, 브라우저 로컬)
        today() {
            let d = new Date();
            let mm = String(d.getMonth() + 1);
            let dd = String(d.getDate());
            return d.getFullYear() + '-' + (mm.length < 2 ? '0' + mm : mm) + '-' + (dd.length < 2 ? '0' + dd : dd);
        },

        show() {
            UIkit.modal(this.$refs.modal).show();
        },

        /**
         * 공통 ajax
         * @return Promise
         */
        request(type, url, data) {
            this.busy = true;
            return new Promise((resolve) => {
                $.app.ajax.module.default({
                    type: type,
                    url: url,
                    dataType: 'json',
                    data: Object.assign({_token: this.csrfToken}, data || {}),
                    success: (response) => {
                        resolve(response);
                    },
                    complete: () => {
                        this.busy = false;
                    },
                });
            });
        },

        done(response) {
            if (response && response.msg) {
                alert(response.msg);
            }
            location.reload();
        },
    },
}
